/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespHeroBannerText_linkData = {
    readonly path: string | null;
    readonly " $fragmentRefs": FragmentRefs<"SeoButton_linkData">;
    readonly " $refType": "HpRespHeroBannerText_linkData";
};
export type HpRespHeroBannerText_linkData$data = HpRespHeroBannerText_linkData;
export type HpRespHeroBannerText_linkData$key = {
    readonly " $data"?: HpRespHeroBannerText_linkData$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespHeroBannerText_linkData">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespHeroBannerText_linkData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SeoButton_linkData"
    }
  ],
  "type": "LinkData",
  "abstractKey": null
};
(node as any).hash = '74388daf4506a7bff5948878d024db9c';
export default node;
